<template>
    <div class="examIndex">
        <!-- <div class="examIndex_back" @click="router.replace('/examStu/myExam')">
            返回
        </div> -->
        <div class="examIndex_box">
            <div class="examIndex_box_info">
                <div class="examIndex_box_info_box">
                    <!-- <div class="examIndex_box_title">{{examInfo.exam_name}}</div> -->
                    <div class="examIndex_box_examTime">开放时间：{{ examInfo.exam_startTime }} ~ {{ examInfo.exam_endTime }}</div>
                    <div class="examIndex_box_examInfo">
                        <div class="examIndex_box_examInfo_left">
                            <div><img src="@img/examStu/examInfo1.png" alt="">总分：<span>{{examInfo.exam_totalScore}}分</span></div>
                            <div><img src="@img/examStu/examInfo2.png" alt="">及格分：<span>{{examInfo.exam_passScore}}分</span></div>
                            <div><img src="@img/examStu/examInfo3.png" alt="">题目数量：<span>{{examInfo.exam_quesNum}}题</span></div>
                            <div><img src="@img/examStu/examInfo3.png" alt="">说明：<div style="white-space: pre-wrap;">{{examInfo.exam_note}}</div></div>
                        </div>
                        <div class="examIndex_box_examInfo_right">
                            <div><img src="@img/examStu/examInfo4.png" alt="">答题时间：<span>{{examInfo.exam_time}}分钟</span></div>
                            <div><img src="@img/examStu/examInfo5.png" alt="">参与人数：<span>{{examInfo.exam_num}}人</span></div>
                            <div></div>
                        </div>
                    </div>
                </div>
                <div class="examIndex_box_button">
                    <el-button type="primary" @click="startExam">开始答题</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ElMessage } from 'element-plus/lib/components/index.js';
import { defineProps} from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter()

const props = defineProps({
    examInfo:{
        type:Object,
    },
    scene:{
        type:String,
        default:function(){
            return ''
        }
    },
    examres_name:{
        type:String,
        default:function(){
            return ''
        }
    },
    examres_phone:{
        type:String,
        default:function(){
            return ''
        }
    }


})

function startExam(){
    const startTime = new Date(props.examInfo.exam_startTime).getTime()
    const endTime = new Date().getTime() && new Date(props.examInfo.exam_endTime).getTime()
    const curTime = new Date().getTime()
    if( endTime > curTime && startTime < curTime){
        if(props.examInfo['exam_status'] == 3){
            return ElMessage.error('考试已完成，等待批阅！')
        }
        let jumpPath='/examStu/examination'
        let obj = {}
        if(props.scene == 'pub'){
            obj['isPub'] = true
            obj['examres_name'] = props.examres_name
            obj['examres_phone'] = props.examres_phone
            jumpPath='/pub'+jumpPath
        }
        router.push({
            path:jumpPath,
            query:{
                id:props.examInfo.examres_id,
                ...obj,
            }
        })
    }else if( new Date(props.examInfo.exam_startTime).getTime() > new Date().getTime()){
        return ElMessage.error('考试未开始')
    }else{
        return ElMessage.error('考试已结束')
    }
}


</script>

<style scoped lang="scss">
.examIndex{
    position: relative;
    width: 100%;
    height: 100%;
    background-color: #fff;
    .examIndex_back{
        position: absolute;
        top: 20px;
        left: 20px;
        cursor: pointer;
        font-size: 16px;
        line-height: 16px;
        color: #808080;
    }
    .examIndex_box{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        overflow: auto;
        .examIndex_box_info{
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: 80%;
            max-width: 80%;
            height: 100%;
            padding-bottom: 40px;
            .examIndex_box_info_box{
                display: flex;
                flex-direction: column;
                flex-grow: 1;
                /* .examIndex_box_title{
                    text-align: center;
                    font-size: 24px;
                    line-height: 1.3;
                    font-weight: 600;
                    color: #303033;
                } */
                .examIndex_box_examTime{
                    text-align: center;
                    margin-top: 14px;
                    font-size: 14px;
                    line-height: 24px;
                    color: #909099;
                }
                .examIndex_box_examInfo{
                    width: 100%;
                    margin-top: 30px;
                    height: 220px;
                    display: flex;
                    background-color: #FAFAFA;
                    .examIndex_box_examInfo_left{
                        display: flex;
                        align-content: flex-start;
                    }
                    &>div{
                        flex: 1;
                        display: flex;
                        flex-direction: column;
                        padding: 36px 12px;
                        font-size: 14px;
                        line-height: 24px;
                        color: #808080;
                        img{
                            width: 16px;
                            height: 16px;
                            margin-right: 12px;
                        }
                        span{
                            color: #303033;
                        }
                        div{
                            height: 40px;
                            display: flex;
                            align-items: center;
                        }
                    }
                }
                .examIndex_box_examDescripe{
                    flex-grow: 1;
                    padding-top: 18px;
                    display: flex;
                    justify-content: center;
                    flex-direction: column;
                    background-color: #FAFAFA;
                    margin-bottom: 16px;
                    .examIndex_box_examDescripe_title{
                        display: flex;
                        align-items: center;
                        font-size: 14px;
                        line-height: 24px;
                        color: #808080;
                        width: 50%;
                        justify-content: center;
                        img{
                            width: 16px;
                            height: 16px;
                            margin-right: 12px;
                        }
                    }
                    .examIndex_box_examDescripe_content{
                        flex-grow: 1;
                        margin-top: 18px;
                        div::-webkit-scrollbar{
                            width: 6px;
                            height: 6px;
                        }
                        div{
                            overflow: scroll;
                            height: 100%;
                            padding-left: 34px;
                            font-size: 14px;
                            color: #808080;
                            line-height: 18px;
                        }
                    }
                }
            }
            .examIndex_box_button{
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;
            }

        }
    }
}
</style>